<template>
  <div class="user-menu">
    <div class="cont-options" :class="{ 'active': showMenu }">
      <div class="user-name">
        <a :href="profileUrl"> Hola, {{ nick }} </a>
      </div>
      <ul :class="menuClass">
        <li v-for="item in urls">
          <a @click.stop="sendDatalayerSubscriptionEvent(item)" :href="item.url">{{ item.text }}</a>
        </li>
      </ul>
      <button class="btn-close" @click="$emit('click')">
        <i class="icon-close"></i>
        <span> Volver </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'edi-menu',
  props: {
    nick: String,
    urls: Array,
    showMenu: Boolean,
    profileUrl: String,
    menuClass: String
  },
  methods: {
    sendDatalayerSubscriptionEvent(item) {
      if (item['data-dl-subscription-params'] === 'undefined') {
        return;
      }

      let eventData = {};
      const dataDlSubscriptionParams = JSON.parse(item['data-dl-subscription-params']);
      if (dataDlSubscriptionParams !== undefined) {
        eventData = dataDlSubscriptionParams;
      }
      window.dataLayer.push({event: 'click_suscription', eventData: eventData });
    },
  },
}
</script>
